import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Admin from './pages/Admin';
import { LanguageProvider } from './context/LanguageContext';
import MTMenuButton from './components/MTMenuButton';
import './styles/index.css';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <MTMenuButton />
        </>
      </Router>
    </LanguageProvider>
  );
}

export default App;
